import { Typography } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import SimulationEvolutionIcon from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/cellRenderer/SimulationEvolutionIcon';
import { SimulationDateString } from 'routes/HumanResourcesModule/Simulation/helpers/types';

import { DateString } from 'routes/HumanResourcesModule/business/types';
import Flex from 'ui/Flex/Flex';

type Props = ICellRendererParams & {
    date: DateString;
    isEmployerCost: boolean;
    isMonthly: boolean;
    currentField: string;
    fieldToCompare: string;
    startDate: SimulationDateString;
};

// for a given cell, we will get the simulated value associated to the same date
const getValueToCompare = (params: Props): number | undefined => {
    const { currentField, fieldToCompare } = params;
    const simulatedField = params.colDef?.field?.replace(
        currentField,
        fieldToCompare,
    );

    if (!simulatedField) return undefined;

    // if the cell is aggregated, we will get the aggregated value for simulated amount
    const isAggregated = 'aggData' in params.node;
    const simulatedValue = isAggregated
        ? params.node.aggData[simulatedField]
        : params.data[simulatedField];
    return simulatedValue;
};

const getFormattedValue = (
    params: ICellRendererParams,
    value: number,
): string =>
    params?.colDef?.valueFormatter &&
    params.column &&
    typeof params.colDef.valueFormatter === 'function'
        ? params?.colDef?.valueFormatter({
              ...params,
              column: params.column,
              colDef: params.colDef,
              value,
          })
        : value?.toLocaleString();

const CustomResultColumnCellRenderer = (params: Props): React.ReactElement => {
    const simulatedValue = getValueToCompare(params);
    const formattedValue =
        params.valueFormatted || getFormattedValue(params, params.value || 0);

    return (
        <Flex sx={{ alignContent: 'space-between' }}>
            <SimulationEvolutionIcon
                value={params.value}
                simulatedValue={simulatedValue}
                isMonthly={params.isMonthly}
                date={params.date}
            />
            <Typography
                sx={{
                    fontSize: '11px',
                    marginLeft: '0.5rem',
                }}
            >
                {formattedValue}
            </Typography>
        </Flex>
    );
};

export default CustomResultColumnCellRenderer;
